import { all } from "redux-saga/effects";
import { thoiKhoaBieuSaga } from "./thoiKhoaBieuSaga";
import { xepTKBSaga } from "./xepTKBSaga";
import { phanPhongHocSaga } from "./phanPhongHocSaga";
import { xepTKBLopTCSaga } from "./xepTKBLopTCSaga";
import { peSaga } from "./peSaga";

export default function* tkbSaga() {
  yield all([
    thoiKhoaBieuSaga(),
    xepTKBSaga(),
    phanPhongHocSaga(),
    xepTKBLopTCSaga(),
    peSaga()
  ]);
}
